import { Grid } from "@mui/material";
import { AutocompleteInput, required, useGetList, useNotify, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { DoctoralServicePath } from "utils/constants";
import { doctoralSeatLabel } from "../../seatLabel";
import SeatFormShell from "./SeatFormShell";
import { useNotifyError } from "utils/useNotifyError";

const AddSeatForm = ({ campaign, onDone }) => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const { data: eligibleSeats = [] } = useGetList(
    `${DoctoralServicePath}doctoral-seats/eligible-for-campaign`,
    {
      pagination: { page: 1, perPage: 1000 },
      filter: { structuralUnitId: campaign?.structuralUnitId, campaignId: campaign?.id },
    },
    { enabled: !!campaign?.structuralUnitId },
  );

  if (!campaign?.structuralUnitId) {
    return (
      <Grid sx={{ p: 2, color: "error.main" }}>
        Кампанията няма зададен факултет. Редактирайте кампанията и задайте факултет.
      </Grid>
    );
  }

  const handleSave = async data => {
    try {
      await dataProvider.customRequest(doctoralRequests.addCampaignSeat(campaign.id), data, "POST");
      notify("Мястото е добавено успешно", { type: "success" });
      refresh();
      onDone();
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <SeatFormShell
      onSubmit={handleSave}
      onCancel={onDone}
      seatPicker={
        <AutocompleteInput
          source="doctoralSeatId"
          label="Докторантско място"
          choices={eligibleSeats}
          optionText={r => doctoralSeatLabel(r)}
          fullWidth
          validate={required()}
        />
      }
    />
  );
};

export default AddSeatForm;
